module.exports = __webpack_public_path__ + "images/The_RealReal-8f0513.png";